import { render } from "./OtherCarInfo.vue?vue&type=template&id=ecc30516&ts=true"
import script from "./OtherCarInfo.vue?vue&type=script&lang=ts"
export * from "./OtherCarInfo.vue?vue&type=script&lang=ts"

import "./OtherCarInfo.vue?vue&type=style&index=0&id=ecc30516&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__